<script setup lang="ts">
import { computed } from 'vue';
import { Typography } from '@apparatix/library/core';
import type { Content } from '@apparatix/types/AccountProfiles';
import { useAiProfileValidation, useStringFunctions } from '@apparatix/composables';
import InvalidProfileContent from './InvalidProfileContent.vue';

type Props = {
  contents: Content<'blob'>;
}

const props = defineProps<Props>();

const { validateBlobSchema } = useAiProfileValidation();

const { isEmptyString } = useStringFunctions();

const isEmpty = computed(() => isEmptyString(props.contents, true));

const isValidSchema = computed(() => validateBlobSchema(props.contents));
</script>
<template>
  <Typography v-if="isValidSchema" variant="body">
    {{ props.contents }}
  </Typography>
  <InvalidProfileContent v-if="!isValidSchema" :empty="isEmpty" />
</template>
